module.exports = __webpack_public_path__ + "static/student-sandbox-bg-xl-0313b64b382dc1f8a7694063c2da67ce.jpg";